(function () {
  function closeDrawer() {
    document.body.classList.remove('collection-sidebar--open');
    var drawer = document.getElementById('ev-filter-drawer');
    if (drawer) drawer.setAttribute('aria-hidden', 'true');
  }

  function openDrawer() {
    var drawer = document.getElementById('ev-filter-drawer');
    if (drawer) drawer.setAttribute('aria-hidden', 'false');
  }

  function syncDrawerState() {
    if (document.body.classList.contains('collection-sidebar--open')) {
      openDrawer();
    } else {
      closeDrawer();
    }
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && document.body.classList.contains('collection-sidebar--open')) {
      event.preventDefault();
      closeDrawer();
    }
  });

  document.addEventListener('click', function (event) {
    if (!document.querySelector('.page-collection.filter_drawer')) return;

    if (event.target.closest('.page-collection.filter_drawer .collection-sidebar__overlay')) {
      closeDrawer();
      return;
    }

    if (event.target.closest('.js-sidebar-toggle')) {
      window.setTimeout(syncDrawerState, 0);
    }
  });
})();
